
























import RouteTab from '@/components/RouteTab.vue';
import { replaceTab } from '@/common/RouteUtils';
import TreeView from '@/components/display/tree.vue';
import RawDataTable from './raw-data-table.vue';

import { capitalize } from '@amcharts/amcharts4/.internal/core/utils/Utils';
import { Transceiver } from '@/api';
import { chimeraRawDataTypeValues, classicRawDataTypeValues, rawDataTabs } from './raw-data-utils';
import { Vue, Emit, Prop, Component, Watch } from 'vue-property-decorator';

@Component({
	methods: { capitalize },
	components: {
		RouteTab,
		TreeView,
		RawDataTable,
	},
})
export default class RawData extends Vue {
	@Prop({ type: Object })
	public transceiver?: Transceiver;

	@Prop({ type: String })
	public readonly routePrefix?: string;
	public filter: string = '';

	public get transceiverId(): number {
		return this.transceiver?.id || 0;
	}

	@Emit('reload')
	public reload() {}

	public get tabs() {
		const types = this.transceiver?.isClassic ? classicRawDataTypeValues : chimeraRawDataTypeValues;
		return rawDataTabs.filter(tab => types.includes(tab.type));
	}

	@Watch('$route', { immediate: true })
	@Watch('tabs')
	public ensureAvailableTab(): void {
		if (
			!this.transceiver ||
			!this.routePrefix ||
			!this.$route?.name?.startsWith(`${this.routePrefix}.`) ||
			String(this.$route.params.transceiverId) !== String(this.transceiverId) ||
			this.tabs.some(tab => this.$route.name === `${this.routePrefix}.${tab.path}`)
		)
			return;
		replaceTab(this.$router, `${this.routePrefix}.all`);
	}

	public handleSearch(vertex: any) {
		this.filter = vertex.entity.uniqueId;
	}
}
